var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_import",
    "data-name": "vuesax/outline/import",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "import"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.442,9.129a1.669,1.669,0,0,1-1.192-.495L.489,2.874A1.686,1.686,0,0,1,2.874.489L7.442,5.057,12.009.489a1.686,1.686,0,0,1,2.385,2.385l-5.76,5.76A1.669,1.669,0,0,1,7.442,9.129Z",
    transform: "translate(19.288 24.598)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.688,26.257A1.7,1.7,0,0,1,0,24.57V1.688A1.7,1.7,0,0,1,1.688,0,1.7,1.7,0,0,1,3.375,1.688V24.57A1.7,1.7,0,0,1,1.688,26.257Z",
    transform: "translate(25.042 7.313)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M19.688,21.375C8.1,21.375,0,13.275,0,1.688A1.7,1.7,0,0,1,1.688,0,1.7,1.7,0,0,1,3.375,1.688C3.375,11.3,10.08,18,19.688,18S36,11.3,36,1.688a1.688,1.688,0,0,1,3.375,0C39.375,13.275,31.275,21.375,19.688,21.375Z",
    transform: "translate(7.313 25.718)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H54V54H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ce02431b3ad9f68ee3eb1819013abd25.svg";
export { ForwardRef as ReactComponent };